/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { ImageElement } from "components";

import userRouteMap from "routes/User/userRouteMap";
import { commonService } from "services/common.service";
import { BROKER_ENDPOINT } from "apiEndpoints";
import socketEventManager from "socket/socketEvents";

function AmenitiesFilm() {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState({
    media: [],
    isLoading: true,
    isLoop: false,
  });

  const getPageDatails = async () => {
    try {
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getCategoryDetails(location.state.id),
      });
      setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          media: response?.data?.data ?? [],
          isLoading: false,
        }));
      }, 2000);
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  const handleOnLoadSocketCommand = (item) => {
    console.log("item", item);
    const object = {
      hardware_id: item?.hardware_id,
      broker_id: item?.broker_id,
      sub_sub_category_id: item?.sub_sub_category_id,
      type: "video",
      video_id: item?.id,
      video_url: item?.image_name,
      "action": "play",
      "video_loop": "yes",
    }
    socketEventManager.sendCommand(item?.hardware_id, object);
  }

  useEffect(() => {
    if (!location.state) {
      navigate("/");
    } else {
      getPageDatails();
    }
  }, []);

  return (
    <div className="amenitiesFilm">
      <Container fluid className="p-0">
        <Row className="gx-0">
          <Col sm={12}>
            <div className="amenitiesFilm_top w-100 d-flex align-items-center justify-content-between">
              <Row className="gx-0 w-100">
                <Col className="col-md-6 col-2">
                  <Link
                    className="commonBack text-uppercase d-block h-auto"
                    onClick={() => navigate(-1)}
                  >
                    <em className="icon-back" />
                    <span className="d-block">Back</span>
                  </Link>
                </Col>
                <Col className="align-self-center col-md-6 col-10">
                  <header className="header d-flex align-items-center">
                    <div className="header_title mx-auto">
                      <h1 className="mb-0 p-0">AMENITIES DISPLAY</h1>
                    </div>
                    <Link
                      className="header_logo"
                      to={userRouteMap.LANDING.path}
                    >
                      <ImageElement
                        imageFor="user"
                        source="logo.svg"
                        className="img-fluid"
                      />
                    </Link>
                  </header>
                </Col>
              </Row>
            </div>
            {state.isLoading ? (
              <div className="d-flex justify-content-center align-items-center vh-100">
                <Spinner />
              </div>
            ) : !state.isLoading && state.media?.length > 0 ? (
              <div className="amenitiesFilm_inner d-flex flex-column justify-content-between align-items-center">
                <div className="amenitiesFilm_cnt w-100 text-center d-flex justify-content-center align-items-center">
                  {state.media?.[0]?.media?.media_type === "video" ? (
                    <div className="ratio ratio-4x3" >
                      <video
                        controls
                        loop={state.isLoop}
                        autoPlay
                        className="mw-100 w-100 h-100 object-fit-cover"
                        onLoadedData={() => handleOnLoadSocketCommand(state.media?.[0])}
                      >
                        <source
                          src={state.media?.[0]?.image_name}
                          // src='http://localhost//broker-pwa-api////public//uploads//test-video-file//4k-low-33Mbps-H264.mp4'
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  ) : (
                    <ImageElement
                      imageFor="user"
                      previewSource={state.media?.[0]?.media?.image_name}

                      className="mw-100 w-auto h-100 object-fit-cover"
                    />
                  )}
                </div>
                <div className="amenitiesFilm_btm w-100 d-flex justify-content-center">
                  <div className="customSwitch d-flex align-items-center">
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={state.isLoop}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            isLoop: e.target.checked,
                          }))
                        }
                      />
                      <span className="slider" />
                    </label>
                    <span className="switchLabel">LOOP</span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center vh-100">
                No data found
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AmenitiesFilm;
